export const Logo = ({ height = "h-11", boxed = false }) => (
  <img
    src="/proplox-logo.png"
    alt="PropLoX"
    data-testid="proplox-logo"
    className={`${height} w-auto object-contain object-left ${boxed ? "rounded-md bg-white p-1.5" : ""}`}
  />
);
